<div class="w-100 d-md-block">
  <div class="create-buttons" *appHideForGuest>
    <button class="add-item-btn" (click)="onNewSchoolClubOrChapterGroup(); false">+ Create Club</button>
    <button class="add-item-btn" (click)="onNewPrivateGroup(); false">+ Create Private Group</button>
  </div>
  <div class="sub-categories-wrap">
    <div class="sub-categories-section">
      <div
        class="sub-categories-item"
        [appRouterLink]="['/groups', 'clubs']"
        appRouterLinkActive="active"
        [amplitude]="'/groups/clubs'"
        >School Clubs & Chapters</div
      >
      <a class="sub-categories-item" [href]="'competitions' | appBaseUrl" target="_blank" [amplitude]="'/competitions'"
        >Competitions & Club Projects
      </a>
    </div>
    <div class="sub-categories-section" *appHideForGuest>
      <div
        class="sub-categories-item"
        [appRouterLink]="['/groups', 'subscribed-clubs']"
        appRouterLinkActive="active"
        appRouterLinkMatcher="^/groups/subscribed-clubs"
        [amplitude]="'/groups/subscribed-clubs'"
        *appHideForGuest
        >My Clubs</div
      >
      <div
        class="sub-categories-item"
        [appRouterLink]="['/groups', 'subscribed-private']"
        appRouterLinkActive="active"
        appRouterLinkMatcher="^/groups/subscribed-private"
        [amplitude]="'/groups/subscribed-private'"
        *appHideForGuest
        >My Groups</div
      >

      <a
        class="sub-categories-item"
        [href]="'competitions#my' | appBaseUrl"
        target="_blank"
        [amplitude]="'/competitions#my'"
        *appHideForGuest
        >My Competitions
      </a>
    </div>

    <!--    <div-->
    <!--      class="sub-categories-item"-->
    <!--      [appRouterLink]="['/groups', 'private']"-->
    <!--      appRouterLinkActive="active"-->
    <!--      [amplitude]="'/groups/private'"-->
    <!--      *appHideForGuest-->
    <!--      >Private groups</div-->
    <!--    >-->
  </div>

  <div class="container d-flex flex-column flex-lg-row">
    <ng-container [ngSwitch]="type$ | async">
      <!-- TODO: Refactor -->
      <div
        class="ceils-content-wrapper d-flex flex-column"
        [class.business-block]="(type$ | async) === TYPE.Clubs || (type$ | async) === TYPE.SubscribedClubs"
        *ngSwitchDefault
      >
        <ng-container *ngIf="(type$ | async) === TYPE.Clubs && !(groups$ | async).items; else groups">
          <app-loader-2 *ngIf="category; else select"></app-loader-2>
          <ng-template #select>
            <div class="group-categories">
              <app-groups-categories (select)="onSelectCategory($event)"></app-groups-categories>
              <div class="foot-text d-flex">
                <div class="icon">
                  <svg viewBox="0 0 16 16">
                    <use href="#new-info" />
                  </svg>
                </div>
                <div class="text">
                  You can create a group, club or chapter and link it to your school or organization you are part of. It
                  could be a general group for students in your school or specific club for your members.
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #groups>
          <app-loader-2 *ngIf="(groups$ | async).isLoading"></app-loader-2>
          <ng-container *ngIf="(groups$ | async).items as groups">
            <ng-container *ngIf="(orgs$ | async).items as orgs">
              <div
                class="ceils-content-wrapper business-block d-flex flex-column"
                *ngIf="(type$ | async) === TYPE.Clubs"
              >
                <div class="business-block-wrap">
                  <div class="business-block-header">
                    <!--                  {{categoryID | groupCategoryName}} organizations-->
                    Start a chapter for one of these organizations
                  </div>
                  <section
                    *ngIf="!orgs.length"
                    class="d-flex flex-wrap flex-column flex-md-row justify-content-md-center ceils-content-section align-items-center"
                  >
                    <h2>There are currently no organizations</h2>
                  </section>
                  <section
                    *ngIf="orgs.length"
                    class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section"
                  >
                    <app-business-org-item
                      class="ceil-article-item business-block-item"
                      [item]="item"
                      *ngFor="let item of orgs"
                    >
                    </app-business-org-item>
                  </section>
                  <!--                <app-page-counter *ngIf="amountOfOrgsPages$ | async" [currentPage]="pageOrg"-->
                  <!--                  [amountOfPages]="amountOfOrgsPages$ | async" (setPage)="onSetPage($event, false)" class="mt-md-auto">-->
                  <!--                </app-page-counter>-->
                </div>

                <div class="business-block-wrap">
                  <div class="business-block-header">
                    Club Projects & Content
                    <app-loader-three-dots *ngIf="isProjectsLoading$ | async"></app-loader-three-dots>
                  </div>

                  <section
                    class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section"
                  >
                    <app-projects [category]="category" class="w-100"></app-projects>
                  </section>
                </div>

                <div class="business-block-wrap">
                  <div class="business-block-header"> {{categoryID | groupCategoryName}} clubs </div>
                  <!--                <section *ngIf="!groups.length"-->
                  <!--                  class="d-flex flex-wrap flex-column flex-md-row justify-content-md-center ceils-content-section align-items-center">-->
                  <!--                  <h2>-->
                  <!--                    You can create a group, club or chapter and link it to your school or organization you-->
                  <!--                    are part of. It could be a general group for students in your school or-->
                  <!--                    specific club for your members.-->
                  <!--                  </h2>-->
                  <!--                </section>-->
                  <section
                    *ngIf="!groups.length"
                    class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section"
                  >
                    <div
                      class="ceil-article-item business-block-item ceil-add-item flex-column justify-content-center align-items-center"
                      (click)="onNewSchoolClubOrChapterGroup(); false"
                    >
                      <div class="add-icon">
                        <svg viewBox="0 0 26 26">
                          <use href="#add-icon" />
                        </svg>
                      </div>
                      <div class="add-text"> Create new club or chapter </div>
                    </div>
                    <div class="ceil-article-item business-block-item">
                      <div class="foot-text d-flex">
                        <div class="foot-text-icon">
                          <svg viewBox="0 0 16 16">
                            <use href="#new-info" />
                          </svg>
                        </div>
                        <div class="text">
                          You can create a group, club or chapter and link it to your school or organization you are
                          part of. It could be a general group for students in your school or specific club for your
                          members.
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    *ngIf="groups.length"
                    class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section"
                  >
                    <app-business-club-item
                      class="ceil-article-item business-block-item"
                      [club]="group"
                      *ngFor="let group of groups"
                      (joinEvent)="joinEventsGroup($event)"
                    >
                    </app-business-club-item>
                    <app-page-counter
                      *ngIf="amountOfPages$ | async"
                      [currentPage]="page"
                      [amountOfPages]="amountOfPages$ | async"
                      (setPage)="onSetPage($event, true)"
                      class="mt-md-auto"
                    >
                    </app-page-counter>
                  </section>
                </div>
              </div>
            </ng-container>

            <ng-container>
              <section
                *ngIf="!groups.length"
                class="d-flex flex-wrap flex-column flex-md-row justify-content-md-center ceils-content-section align-items-center"
              >
                <h2 *ngIf="(type$ | async) === TYPE.Private">There are currently no private groups</h2>
              </section>
              <section
                *ngIf="groups.length && (type$ | async) !== TYPE.Clubs && (type$ | async) !== TYPE.SubscribedClubs"
                class="d-flex flex-wrap flex-column flex-md-row ceils-content-section margin-t-2"
              >
                <app-group-item
                  class="ceil-article-item"
                  [group]="group"
                  *ngFor="let group of groups"
                  (joinEvent)="joinEventsGroup($event)"
                >
                </app-group-item>
                <app-page-counter
                  *ngIf="amountOfPages$ | async"
                  [currentPage]="page"
                  [amountOfPages]="amountOfPages$ | async"
                  (setPage)="onSetPage($event, true)"
                  class="mt-md-auto"
                >
                </app-page-counter>
              </section>
              <div *ngIf="groups.length && (type$ | async) === TYPE.SubscribedClubs" class="business-block-wrap">
                <section
                  class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section"
                >
                  <app-business-club-item
                    class="ceil-article-item business-block-item"
                    [club]="group"
                    *ngFor="let group of groups | orderBy: ['members', 'id']: ['desc', 'desc'];"
                    (joinEvent)="joinEventsGroup($event)"
                  >
                  </app-business-club-item>
                  <app-page-counter
                    *ngIf="amountOfPages$ | async"
                    [currentPage]="page"
                    [amountOfPages]="amountOfPages$ | async"
                    (setPage)="onSetPage($event, true)"
                    class="mt-md-auto"
                  >
                  </app-page-counter>
                </section>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
